import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
export default function UserCard({ data, callBack ,textDesc}) {
  return (
    <Card
      sx={{
        width: "90%",
        mt: "10px",
        backgroundColor: "#E3E3FF",
        borderRadius: "8px",
        padding: "10px 16px",
        cursor: "pointer",
        margin: "8px auto",
        ":hover": {
          bgcolor: "#2892ba17",
        },
      }}
      onClick={callBack}
      //   onClick={setEditedItem}
    >
      <CardContent sx={{ p: "0px 15px !important" }}>
        <Grid container>
          <Grid item xs={12}>
            <Typography
              color="primary"
              sx={{
                fontSize: { xs: "10px", sm: "16px" },

                overflow: "Hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
                p: 0,
                m: 0,
              }}
            >
              {textDesc ? textDesc : data?.description}
            </Typography>
            <Typography sx={{ fontSize: "14px" }}> {data?.mobile}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
